import * as React from 'react';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Divider from '@mui/material/Divider';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import Collapse from '@mui/material/Collapse';
import ListSubheader from '@mui/material/ListSubheader';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import TokenCountdown from '../../shared/TokenCountdown';

export default function NavigationDrawerContent({
  sections,
  expandedSections,
  drawerWidth,
  onToggleSection,
  onNavigate,
}) {
  const renderItem = (item, options = {}) => {
    const { nested = false, basePadding = 2 } = options;
    const paddingLeft = nested ? basePadding + 2 : basePadding;

    return (
      <ListItemButton
        key={item.path}
        sx={{pl: paddingLeft}}
        onClick={() => item.path && onNavigate(item.path)}
        disabled={!item.path}
      >
        <ListItemText primary={item.label} />
      </ListItemButton>
    );
  };

  const renderItems = (items, basePadding) => (
    items.map((item) => (
      <React.Fragment key={item.path || item.label}>
        {renderItem(item, {basePadding})}
        {item.children?.length > 0 && (
          <List component="div" disablePadding>
            {item.children.map((child) => renderItem(child, {nested: true, basePadding}))}
          </List>
        )}
      </React.Fragment>
    ))
  );

  return (
    <Box sx={{width: drawerWidth}} role="presentation">
      <Toolbar />
      <Divider />
      <TokenCountdown variant="drawer" />
      {sections.map((section) => {
        const isCollapsible = Boolean(section.collapsible);
        const isOpen = expandedSections[section.title];

        return (
          <List
            key={section.title}
            subheader={
              !isCollapsible ? (
                <ListSubheader disableSticky sx={{fontWeight: 600, color: 'text.primary'}}>
                  {section.title}
                </ListSubheader>
              ) : undefined
            }
          >
            {isCollapsible ? (
              <>
                <ListItemButton onClick={() => onToggleSection(section.title)}>
                  <ListItemText primary={section.title} primaryTypographyProps={{fontWeight: 600}} />
                  {isOpen ? <ExpandLess /> : <ExpandMore />}
                </ListItemButton>
                <Collapse in={isOpen} timeout="auto" unmountOnExit>
                  <List component="div" disablePadding>
                    {renderItems(section.items, 4)}
                  </List>
                </Collapse>
              </>
            ) : (
              renderItems(section.items, 2)
            )}
          </List>
        );
      })}
    </Box>
  );
}
